import { render, staticRenderFns } from "./KlineWaveConfigSave.vue?vue&type=template&id=d67c1d7c&scoped=true"
import script from "./KlineWaveConfigSave.vue?vue&type=script&lang=js"
export * from "./KlineWaveConfigSave.vue?vue&type=script&lang=js"
import style0 from "./KlineWaveConfigSave.vue?vue&type=style&index=0&id=d67c1d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67c1d7c",
  null
  
)

export default component.exports